import { useRef } from 'react';
import { Inline, Stack } from '@etg/wings';
import { carouselWrapper, inlineFlex, travelerList } from '../utils/styles';
import SeatMapTravelerList from './SeatMapTravelerList';
import SingleTravelerButton from './SingleTravelerButton';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapTravelersMobileTabs = _ref => {
  let {
    activeSeatAssignments,
    activeSegment,
    activeTraveler,
    isRyanairInTrip,
    onChange,
    onRemoveSeat,
    seatTravelers,
    setTravelerButtonWithRemoveLink,
    travelerButtonWithRemoveLink
  } = _ref;
  const seatMapTravelersRef = useRef(null);
  const seatMapTravelersListRef = useRef(null);
  const seatMapTravelersWrapperRef = useRef(null);
  const isSingleTraveler = seatTravelers.length === 1;
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "seatMap-travelers-mobile-tabs",
    ref: seatMapTravelersRef,
    children: /*#__PURE__*/_jsx(Inline, {
      className: carouselWrapper,
      ref: seatMapTravelersWrapperRef,
      children: isSingleTraveler ? /*#__PURE__*/_jsx(Inline, {
        className: inlineFlex,
        children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SingleTravelerButton, {
          activeSeatAssignments: activeSeatAssignments,
          activeSegment: activeSegment,
          activeTraveler: activeTraveler,
          isRyanairInTrip: isRyanairInTrip,
          isSingleTraveler: isSingleTraveler,
          onChange: onChange,
          onRemoveSeat: onRemoveSeat,
          setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
          traveler: traveler,
          travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
        }, traveler.id))
      }) : /*#__PURE__*/_jsx("ul", {
        className: travelerList,
        ref: seatMapTravelersListRef,
        children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SeatMapTravelerList, {
          activeSeatAssignments: activeSeatAssignments,
          activeTraveler: activeTraveler,
          id: traveler.id,
          isRyanairInTrip: isRyanairInTrip,
          name: traveler.name || null,
          onChange: onChange,
          onRemoveSeat: onRemoveSeat(activeSegment, traveler.id),
          setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
          travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
        }, traveler.id))
      })
    })
  });
};
export default SeatMapTravelersMobileTabs;
//# sourceMappingURL=SeatMapTravelersMobileTabs.js.map